import { Controller } from '@hotwired/stimulus';

/** Revenue summary card: switch between 7d, 30d, and lifetime panels. */
export default class extends Controller {
  static targets = ['panel', 'button'];

  static values = {
    period: { type: String, default: '30d' },
  };

  connect() {
    this.show(this.periodValue);
  }

  select(event) {
    const { period } = event.currentTarget.dataset;
    if (!period) return;

    this.periodValue = period;
  }

  periodValueChanged() {
    this.show(this.periodValue);
  }

  show(period) {
    this.panelTargets.forEach((panel) => {
      const active = panel.dataset.period === period;
      panel.classList.toggle('is-active', active);
      panel.toggleAttribute('inert', !active);
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    this.buttonTargets.forEach((button) => {
      const active = button.dataset.period === period;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
      button.tabIndex = active ? 0 : -1;
    });
  }
}
